import { attributesToProps } from 'html-react-parser';
import { getWordpressStyles, renderChild } from '@/app_lib/htmlParser/parsers/parserOptions';
import type { ParserProps } from '@/app_lib/htmlParser/types';
import { cn } from '@/app_lib/utils/utils';

export const FigureParser = ({ domNode }: ParserProps) => {
  const { attribs, children } = domNode;
  const props = attributesToProps(attribs);
  const { style: _style, className, ...rest } = props;

  const newClasses = getWordpressStyles(className?.toString() || '');

  return (
    <figure
      className={cn(newClasses, className).replace('size-full', '')}
      {...rest}
    >
      {renderChild(children)}
    </figure>
  );
};
